const React = require('react');
const PropTypes = require('prop-types');
const { Errors } = require('react-redux-form');
const classNames = require('classnames');
import InputMask from 'react-input-mask';
import './GeoInput.scss';

class GeoInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value == null ? '' : props.value,
            classFocus: false,
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.value !== newProps.value) {
            let value = newProps.value;
            if (this.props.maxLength > 0) {
                value = value.substr(0, this.props.maxLength);
            }
            this.setState({ value });
            if (this.props.validators) {
                this.props.formActions.validate(
                    `${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`,
                    this.props.validators
                );
            }
            this.props.onUpdate && this.props.onUpdate(newProps.baseModelProperty, value);
        }
    }

    renderLabel() {
        return this.props.label ? <label htmlFor={this.props.id}>{this.props.label}</label> : null;
    }

    renderErrors(props) {
        return <div className="form__field_error">{props.children}</div>;
    }

    changeClassFocus(change) {
        this.setState({
            classFocus: change,
        });
    }

    handleOnChange(event) {
        if (event && event.target.value) {
            if (this.props.maxLength > 0 && event.target.value.length >= this.props.maxLength) {
                this.setState({ value: event.target.value.substr(0, this.props.maxLength) });
            } else {
                this.setState({ value: event.target.value });
            }
        } else {
            this.setState({ value: '' });
        }
    }

    handleOnBlur() {
        let value = this.state.value;
        if (this.props.maxLength > 0) {
            value = value.substr(0, this.props.maxLength);
        }
        this.props.formActions.change(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, value);

        if (this.props.validators) {
            this.props.formActions.validate(
                `${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`,
                this.props.validators
            );
        }
        this.changeClassFocus(false);
    }

    handleOnFocus() {
        this.changeClassFocus(true);
    }

    render() {
        const { classFocus, value } = this.state;
        const {
            id,
            className,
            placeholder,
            disabled,
            errorMessages,
            baseModelDescriptor,
            baseModelProperty,
            size,
            type,
            autoCompleteFieldCustom,
            mask,
            maskChar,
            formatChars,
            subText,
        } = this.props;
        const hasError = !(this.props.baseModelForm?.[baseModelProperty]?.valid ?? true);

        const mainClassNames = classNames(
            'form__input',
            'prospects-geo-input',
            {
                hidden: size === 0,
                'form__input--error': hasError,
                'form__input--focus': classFocus,
            },
            className
        );
        const inputClassNames = classNames({
            'valid-error': hasError,
        });

        return (
            <div ref={this.props.refProp} className={`${mainClassNames} col-sm-${size}`}>
                {this.renderLabel()}
                {this.props.tooltip}
                <InputMask
                    autoComplete={autoCompleteFieldCustom}
                    className={inputClassNames}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    onBlur={this.handleOnBlur}
                    onChange={this.handleOnChange}
                    onFocus={this.handleOnFocus}
                    disabled={disabled}
                    value={value}
                    mask={mask}
                    maskChar={maskChar}
                    formatChars={formatChars}
                />
                {subText && <span className="input-subtext">{subText}</span>}
                <Errors
                    model={`${baseModelDescriptor}.${baseModelProperty}`}
                    messages={errorMessages}
                    component={this.renderErrors}
                />
            </div>
        );
    }
}

GeoInput.propTypes = {
    id: PropTypes.string.isRequired,
    baseModelDescriptor: PropTypes.string, //Injected by GeoAddress
    baseModelProperty: PropTypes.string.isRequired,
    baseModelForm: PropTypes.object,
    formActions: PropTypes.object, //Injected by GeoAddress
    className: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.string,
    tooltip: PropTypes.element,
    errorMessages: PropTypes.object,
    validators: PropTypes.object,
    size: PropTypes.number,
    onUpdate: PropTypes.func,
    maxLength: PropTypes.number,
    autoCompleteFieldCustom: PropTypes.string,
    mask: PropTypes.string,
    maskChar: PropTypes.string,
    formatChars: PropTypes.object,
};

GeoInput.defaultProps = {
    disabled: false,
    size: 12,
    value: '',
    maxLength: 0,
    type: 'text',
    autoCompleteFieldCustom: 'new-text',
    mask: '',
    maskChar: null,
    formatChars: null,
};

module.exports = GeoInput;
